import { useCallback, useEffect, useState } from 'react';
import Layout from '@/shared/Layout/ui/Layout';
import Image from 'next/image';
import { useRouter } from 'next/router';
import * as S from './CartSad.styles';
import backgroundImage from '@/shared/images/Images/EmptyCart-bg.jpg';
import { memo } from 'react';
import CartPageMeta from '../app/Meta/Meta';
import { Preloader } from '@/common/ui/loaders/Preloader';

const TIMEOUT_SECS = 15;

const CartSadContainer = ({ isLoading }: { isLoading?: boolean }) => {
    // Timer for empty cart
    const router = useRouter();
    const [seconds, setSeconds] = useState(TIMEOUT_SECS);

    const redirectToHome = useCallback(() => {
        if (isLoading) return;

        const myInterval = setInterval(() => {
            if (seconds) {
                setSeconds(seconds - 1);
                return;
            }

            router.push('/');
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    }, [router, seconds, isLoading]);

    useEffect(redirectToHome, [redirectToHome, isLoading]);

    return (
        <Layout noFooter>
            <CartPageMeta />
            <S.ModalContainer data-test-id="Sad_cart">
                <S.BGImage data-test-id="BGImage">
                    <Image alt="img" src={backgroundImage} layout="fill" objectFit="cover" />
                </S.BGImage>
                <S.Modal>
                    {isLoading ? (
                        <Preloader maxHeight="300px" minHeight="300px" />
                    ) : (
                        <>
                            <S.CartEmptyHeader>
                                <S.CloseButton onClick={() => router.push('/')}>
                                    <S.CloseButtonWithIcon />
                                </S.CloseButton>
                            </S.CartEmptyHeader>
                            <S.CartEmptyContent>
                                <S.IconCart />
                                <S.CartEmptyTitle>Your cart is sad!</S.CartEmptyTitle>
                                <S.CartEmptyDescription>
                                    Lets find some wonderful activities to do. Get ready to be
                                    inspired...
                                </S.CartEmptyDescription>
                                <S.ButtonSendingHome
                                    variant="primary"
                                    onClick={() => router.push('/')}
                                >
                                    Sending you home in {seconds}
                                </S.ButtonSendingHome>
                            </S.CartEmptyContent>
                        </>
                    )}
                </S.Modal>
            </S.ModalContainer>
        </Layout>
    );
};

export const CartSad = memo(CartSadContainer);
